import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import './Header.css';

const Header = () => {
  const { isDark, toggleTheme } = useTheme();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/projects', label: 'Projects' },
    { path: '/about', label: 'About' },
    { path: '/blog', label: 'Blog' }
  ];

  return (
    <header className={`header ${isScrolled ? 'header--scrolled' : ''}`}>
      <nav className="nav container">
        <div className="nav__brand">
          <Link 
            to="/" 
            className="nav__logo"
            aria-label="Go to home page"
          >
            8adiq
          </Link>
        </div>

        <div className={`nav__menu ${isMobileMenuOpen ? 'nav__menu--open' : ''}`}>
          <ul className="nav__list">
            {navItems.map(item => (
              <li key={item.path} className="nav__item">
                <Link
                  to={item.path}
                  className={`nav__link ${location.pathname === item.path ? 'nav__link--active' : ''}`}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
          
          <button
            className="nav__close"
            onClick={() => setIsMobileMenuOpen(false)}
            aria-label="Close navigation menu"
          >
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="nav__actions">
          <div className="nav__social">
            <a 
              href="mailto:abdullatifsadiq21@email.com" 
              className="nav__social-link"
              aria-label="Email"
            >
              <i className="fas fa-envelope"></i>
            </a>
            <a 
              href="https://linkedin.com/in/abdul-latifsadiq" 
              target="_blank" 
              rel="noopener noreferrer"
              className="nav__social-link"
              aria-label="LinkedIn"
            >
              <i className="fab fa-linkedin"></i>
            </a>
            <a 
              href="https://twitter.com/8adiq" 
              target="_blank" 
              rel="noopener noreferrer"
              className="nav__social-link"
              aria-label="Twitter"
            >
              <i className="fab fa-twitter"></i>
            </a>
            <a 
              href="https://github.com/8adiq" 
              target="_blank" 
              rel="noopener noreferrer"
              className="nav__social-link"
              aria-label="GitHub"
            >
              <i className="fab fa-github"></i>
            </a>
          </div>
          <button
            className="theme-toggle"
            onClick={toggleTheme}
            aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
          >
            <i className={`fas ${isDark ? 'fa-sun' : 'fa-moon'}`}></i>
          </button>
          
          <button
            className="nav__toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle navigation menu"
          >
            <i className="fas fa-bars"></i>
          </button>
        </div>
      </nav>
    </header>
  );
};

export default Header;